import { UnifiedProduct } from '../types/product';
import { CustomerProductPrice } from '../types/productPricing';
import { RelatedProductsData } from '../types/relatedProduct';

export type MergedUnifiedProductsParams = {
  primaryProducts?: UnifiedProduct[];
  pricingData?: CustomerProductPrice[];
  relatedProductsData?: RelatedProductsData[];
  isProductsByGroupCodeQueryEnabled?: boolean;
};

export const mergeUnifiedPrimaryProductsAndRelatedData = ({
  primaryProducts = [],
  pricingData = [],
  relatedProductsData = [],
  isProductsByGroupCodeQueryEnabled,
}: MergedUnifiedProductsParams): UnifiedProduct[] => {
  if (!primaryProducts?.length) {
    return [];
  }

  // Create lookup maps for O(1) access instead of O(n) find operations
  const pricingMap = new Map(
    pricingData?.map((pricingEntry) => [
      pricingEntry.masterProductId,
      pricingEntry,
    ])
  );

  const relatedProductsMap = new Map(
    relatedProductsData?.map((relatedProducts) => [
      isProductsByGroupCodeQueryEnabled
        ? relatedProducts.groupCode
        : relatedProducts.masterProductId,
      relatedProducts,
    ])
  );

  // Single iteration through products with O(1) lookups
  return primaryProducts?.map((primaryProduct) => {
    const masterProductId = primaryProduct?.masterProductId;
    const groupCode = primaryProduct?.groupCode;
    const relatedProductsDataForProduct = relatedProductsMap.get(
      isProductsByGroupCodeQueryEnabled ? groupCode : masterProductId
    );

    return {
      ...primaryProduct,
      pricing: pricingMap.get(masterProductId),
      relatedProductsData: relatedProductsDataForProduct,
      // Only used in tracking for Sets/Bundles,
      // passed through via primary product to `trackProductClick()`
      componentProductIdObjectList:
        relatedProductsDataForProduct?.componentProductIdObjectList,
    };
  });
};
